import type { RevisionedLineItem } from '@weft/types';
import { DEFAULT_CURRENCY, type BaseProductLineItem } from '@weft/types';
import { validateNotNullOrUndefined } from '@weft/utils';
import { useInvoice } from 'apps/app/src/hooks/requests/use-invoice';

export function useInvoiceCurrency(lineItems: BaseProductLineItem[] | RevisionedLineItem[]) {
  const invoiceId = getInvoiceId(lineItems);

  const { data: useInvoiceResult } = useInvoice(invoiceId);

  validateNotNullOrUndefined(useInvoiceResult);

  return useInvoiceResult.invoice.contract?.customer.settings?.currency ?? DEFAULT_CURRENCY;
}

function getInvoiceId(lineItems: BaseProductLineItem[] | RevisionedLineItem[]) {
  const invoiceIds = lineItems.map(lineItem => lineItem.invoiceId);
  
  const uniqueInvoiceIds = new Set(invoiceIds);
  
  if (uniqueInvoiceIds.size !== 1) {
    throw new Error('Invoice id is not unique');
  }
  
  return [...uniqueInvoiceIds][0];
}